// eslint-disable-next-line import/prefer-default-export
export const NavigationMenuOptions = Object.freeze({
    BidSetups: 0,
    AwardingRules: 1,
});
